import { Routes } from '@angular/router';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { AuditPageComponent } from "./pages/audit-page/audit-page.component";
import {AuditSetupPageComponent} from "./pages/audit-setup-page/audit-setup-page.component";
import { AuditSummaryPageComponent } from "./pages/audit-summary-page/audit-summary-page.component";
import {AssignmentsPageComponent} from "./pages/assignments-page/assignments-page.component";
import {LoginPageComponent} from "./pages/login-page/login-page.component";
import { MsalGuard } from '@azure/msal-angular';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';

export const routes: Routes = [
  {path: '', component: MainPageComponent, canActivate: [MsalGuard]},
  {path: 'audit-setup', component: AuditSetupPageComponent, canActivate: [MsalGuard]},
  {path: 'audit/:id', component: AuditPageComponent, canActivate: [MsalGuard]},
  {path: 'audit-summary', component: AuditSummaryPageComponent, canActivate: [MsalGuard]},
  {path: 'assignments', component: AssignmentsPageComponent, canActivate: [MsalGuard]},
  {path: 'login', component: LoginPageComponent},
  {path: 'settings', component: SettingsPageComponent, canActivate: [MsalGuard]}
];
